import moment from 'moment';
import { GateSchedule } from 'types/Gates';
import erlClient from '.';
import { Region } from './regions';

interface GateDate {
  weekNumber: number;
  year: number;
}

const getGateDate = (weekOffset = 0): GateDate => {
  const now = moment();
  let year = now.year();
  const nowOffset = now.add(weekOffset, 'w');
  const weekNumber = nowOffset.isoWeek();

  if (nowOffset.year() > year) {
    year = nowOffset.year();
  }

  return { weekNumber, year };
};

export const getGateSchedule = async (
  weekOffset = 0,
  portCollectionCode?: Region['code']
): Promise<GateSchedule> => {
  const { weekNumber, year } = getGateDate(weekOffset);
  const response = await erlClient.get<GateSchedule>(`/core/api/v1/erl/gate_status`, {
    params: {
      week: weekNumber,
      year,
      port_collection_codes: portCollectionCode,
    },
  });
  return response.data;
};
